import { useCallback, useMemo, useRef } from 'react';
import '../Analitos.scss';
import DataGrid, { Column, Button as Butt, Editing, RequiredRule, Form, Toolbar, Item as ItemT } from 'devextreme-react/data-grid';
import { useApiConfiguration } from '../../../api/api.configuration';
import { Item } from 'devextreme-react/form';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { Button, Tooltip } from 'devextreme-react';

export const AlternateRanks = ({ dataRanks, update }) => {
  const dataRef = useRef<DataGrid>(null);
  const { newAlternateRanks, setAlternateRanks, deleteAlternateRanks } = useApiConfiguration();

  const customData = useMemo(() => {
    return new CustomStore({
      key: 'Ra_Id',
      load() {
        return Promise.resolve({
          data: dataRanks,
        }).catch(() => {
          throw new Error('Error de carga de datos');
        });
      },
      insert: async (values) => {
        return newAlternateRanks({ Rango: values })
          .then((res) => {
            if (res === 105) {
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error insertando el rango alterno');
          });
      },
      update: (key, values) => {
        return setAlternateRanks({ RangoAlterno: values, IdRangoAlterno: key })
          .then((res) => {
            if (res === 107) {
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error actualizando el rango alterno');
          });
      },
      remove: (key) => {
        return deleteAlternateRanks({ IdRangoAlterno: key }).then((res) => {
          if (res === 107) {
            dataRef.current?.instance.refresh();
          }
        });
      },
    });
  }, [dataRanks]);

  const customDataSrc = new DataSource({
    store: customData,
    reshapeOnPush: true,
  });

  const handleRefresh = useCallback(() => {
    update();
  }, [update]);

  return (
    <div>
      <DataGrid dataSource={customDataSrc} ref={dataRef}>
        <Editing mode='form' allowUpdating={true} allowAdding={true} allowDeleting={true} selectTextOnEditStart={true}>
          <Form>
            <Item dataField='Ra_Nombre' />
            <Item dataField='Ra_Estado' />
            <Item dataField='Ra_Detalle' editorType='dxTextArea' editorOptions={{ height: 200 }} />
          </Form>
        </Editing>
        <Toolbar>
          <ItemT name='addRowButton' />
          <ItemT location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
            <Button id='RefrecarResult' icon='refresh' text='Refresh' stylingMode='text' onClick={handleRefresh} />
            <Tooltip target={'#RefrecarResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
              Refrescar datos
            </Tooltip>
          </ItemT>
        </Toolbar>
        <Column allowGrouping={false} caption='ID' width={80} visible={true} allowEditing={false} dataField='Ra_Id' alignment='center' />
        <Column allowGrouping={false} caption='RANGO' width={100} visible={true} allowEditing={true} dataField='Ra_Nombre' alignment='center'>
          <RequiredRule />
        </Column>
        <Column allowGrouping={false} caption='DETALLE' width={150} visible={true} allowEditing={true} dataField='Ra_Detalle' alignment='center'>
          <RequiredRule />
        </Column>
        <Column dataType='boolean' allowGrouping={false} width={100} caption='ESTADO' visible={true} allowEditing={true} dataField='Ra_Estado' alignment='center'>
          <RequiredRule />
        </Column>
        <Column type='buttons' caption={'ACCIÓN'} width={100}>
          <Butt name='edit' />
          <Butt name='delete' />
        </Column>
      </DataGrid>
    </div>
  );
};
